export default {
    key: "third_party_reservation_log",
    id: "id",
    action: ["view"],
    export: ["excel"],
    excel: {
        //max_row:"50000"
    },
    sort: {
        field: "id",
        order: "desc"
    },
    sort_fields: [

    ],
    filters:{
        // id:{},
        type: {},
        memberId: {},
        creDttm: {type: "daterange"},
    },

    options: {
    },
    fields:[
        // {type: "action-btn", privilege: ["EDIT_THIRD_PARTY_RESERVATION_LOG"]},
        // { key: "id", field:"rsr_id", width:50},
        {key: "id", width:50},
        {key: "type", width: 150},
        {key: "memberId",width: 150},
        {key: "response"},
        {key: "creDttm", type: "datetime"},
        {type: "action-btn", width: 50},
    ],
    structure:[
        // ["id"],
    ],
    view:[
        ["id"],
        ["destination"],
        ["memberId"],
        ["path"],
        ["method" ,"httpStatusCode", "errorCode"],
        ["request"],
        ["response"],
        [{key: "creDttm", type: "datetime"}],
    ]
}